import {
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import SidebarSection from "./SidebarSection";
import CustomCard from "./CustomCard";
import { IoClose, IoSearch } from "react-icons/io5";
import cardData from "./CardData";
import { useNavigate } from "react-router-dom";
// import Img1 from "./Icon/NoDataImg.jpg";
import Img1 from "./Icon/imgUpgrading.png";
import axios from "axios";

const BlogSection2 = () => {
  //original api start data

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "http://192.168.29.113:5002/api/all_blog"
        );

        setData(response?.data?.blogs);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  console.log("API_blog:======>>>", data);

  // Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  //original api end data

  const [visibleCards, setVisibleCards] = useState(9); // Number of cards currently visible
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showBuffer, setShowBuffer] = useState(false); // Buffering state
  const scrollableRef = useRef(null); // Reference to the scrollable Stack
  const [selectedTags, setSelectedTags] = useState([]); // Selected tags for filtering
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false); // Toggle filter menu visibility

  // Extract unique tags from card data
  const allTags = Array.from(new Set(data.flatMap((card) => card.postChip)));

  const handleShowMore = () => {
    setVisibleCards((prev) => prev + 6); // Show next 6 cards
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
    setVisibleCards(9); // Reset visible cards on search
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setVisibleCards(9); // Reset visible cards on category change
  };

  const handleTagChange = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const filteredCards = data.filter((card) => {
    const matchesSearch =
      card.postTitle.toLowerCase().includes(searchTerm) ||
      card.postChip.some((tag) => tag.toLowerCase().includes(searchTerm));
    const matchesCategory =
      selectedCategory === "All" || card.postCategory === selectedCategory; // yhan pr postTitle li jgh category dalna hai

    const matchesTags =
      selectedTags.length === 0 ||
      selectedTags.every((tag) => card.postChip.includes(tag));

    return matchesSearch && matchesCategory && matchesTags;
  });

  // console.log("filteredCards:=====>>", filteredCards);

  const navigate = useNavigate();

  const handleReadMore = (card) => {
    navigate("/blog-page", { state: card });
  };

  // Handle dialog open
  // const handleReadMore = (card) => {
  //   setSelectedCard(card); // Set the selected card data
  //   setDialogOpen(true); // Open the dialog
  // };

  // Handle dialog close
  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedCard(null); // Clear the selected card
  };

  const handleFilterToggle = () => {
    setIsFilterMenuOpen((prev) => !prev); // Toggle filter menu visibility
  };

  const handleClickAway = () => {
    setIsFilterMenuOpen(false); // Close the menu when clicking outside
  };

  useEffect(() => {
    const handleScroll = () => {
      const element = scrollableRef.current;
      if (element) {
        const atBottom =
          element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
        if (atBottom && !showBuffer && visibleCards < filteredCards.length) {
          // Show buffer only if there are more cards to load
          setShowBuffer(true); // Show buffering
          setTimeout(() => {
            setShowBuffer(false);
            setVisibleCards((prev) => prev + 6); // Show next 6 cards
          }, 2000);
        }
      }
    };

    const scrollableElement = scrollableRef.current;
    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [filteredCards.length, showBuffer, visibleCards]);

  return (
    <Stack>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingTop: {
            xl: "60px",
            lg: "60px",
            md: "60px",
            sm: "60px",
            xs: "0px",
          },
          paddingBottom: {
            xl: "60px",
            lg: "60px",
            md: "60px",
            sm: "60px",
            xs: "0px",
          },
        }}
      >
        {/* heading and subheading */}
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            // marginBottom: {
            //   xl: "12px",
            //   lg: "12px",
            //   md: "12px",
            //   sm: "12px",
            //   xs: "0px",
            // },
            // border: "2px solid red",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid #ddd",
              width: { xl: "68%", lg: "80%", md: "90%", sm: "96%", xs: "100%" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#edf9ff",
              // border: "1px solid red",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "22px", md: "44px" },
                fontWeight: 600,
                color: "rgb(5 78 146)",
              }}
            >
              Blog
            </Typography>
            {/* <Typography
              sx={{
                fontSize: { xs: "16px", md: "24px" },
                fontWeight: 300,
                color: "black",
              }}
            >
              Sub heading
            </Typography> */}
          </Stack>
        </Stack>

        <Stack>
          <Stack
            sx={{
              height: {
                xl: "86vh",
                lg: "86vh",
                md: "86vh",
                sm: "86vh",
                xs: "auto",
              },
              display: "flex",
              flexDirection: { xl: "row", lg: "row", md: "row", sm: "row" },
              justifyContent: "center",
              // border: "2px solid blue",
              backgroundColor: { xs: "#edf9ff", sm: "white" },

              //  backgroundColor: "red",
            }}
          >
            <Stack
              sx={{
                width: { xl: "68%", lg: "80%", md: "90%", sm: "96%" },
                display: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
              }}
            >
              {/* Sidebar Section */}
              <Stack
                sx={{
                  width: { xl: "26%", lg: "26%", md: "20%", sm: "20%" },
                  // border: "1px solid #ddd",
                  // border: "2px solid red",
                  backgroundColor: "#edf9ff",
                }}
              >
                <SidebarSection onCategorySelect={handleCategorySelect} />
              </Stack>

              {/* Card section */}
              <Stack
                // ref={scrollableRef} // Attach the ref here
                sx={{
                  width: { xl: "74%", lg: "74%", md: "80%", sm: "80%" },
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "auto",
                  },
                  position: "relative",
                  overflowY: "auto",
                  // border: "2px solid blue",
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    // border: "2px solid green",
                    // border: "1px solid #ddd",
                    backgroundColor: "#edf9ff",
                    marginBottom: {
                      xl: "16px",
                      lg: "16px",
                      md: "16px",
                      sm: "16px",
                      xs: "16px",
                    },
                    marginTop: {
                      xl: "0px",
                      lg: "0px",
                      md: "0px",
                      sm: "0px",
                      xs: "16px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      // border: "1px solid red",
                      width: {
                        xl: "35%",
                        lg: "35%",
                        md: "35%",
                        sm: "35%",
                        xs: "35%",
                      },
                      height: {
                        xl: "100%",
                        lg: "100%",
                        md: "100%",
                        sm: "100%",
                        xs: "100%",
                      },
                      display: "none",
                    }}
                  >
                    <Stack
                      sx={{
                        paddingLeft: { xl: "4px" },
                        // border: "1px solid blue",
                        // height: "100%",
                      }}
                    >
                      <ClickAwayListener
                        onClickAway={handleClickAway}
                        sx={{ height: "100%" }}
                      >
                        <Stack sx={{ height: "100%" }}>
                          <Stack
                            onClick={handleFilterToggle}
                            sx={{
                              cursor: "pointer",
                              fontWeight: "bold",
                              // backgroundColor: "#f4f4f4",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              height: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: {
                                xl: "20px",
                                lg: "20px",
                                md: "20px",
                                sm: "20px",
                                xs: "31px",
                              },
                              fontFamily:
                                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                            }}
                          >
                            Filter
                          </Stack>
                          {isFilterMenuOpen && (
                            <Stack
                              sx={{
                                position: "absolute",
                                top: "48px",
                                left: "8px",
                                backgroundColor: "white",
                                border: "1px solid #ddd",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                zIndex: 10,
                                padding: "8px",
                                borderRadius: "4px",
                              }}
                            >
                              <FormGroup>
                                {allTags.map((tag, index) => (
                                  <FormControlLabel
                                    key={index}
                                    control={
                                      <Checkbox
                                        checked={selectedTags.includes(tag)}
                                        onChange={() => handleTagChange(tag)}
                                      />
                                    }
                                    label={tag}
                                  />
                                ))}
                              </FormGroup>
                            </Stack>
                          )}
                        </Stack>
                      </ClickAwayListener>
                    </Stack>
                  </Stack>
                  <Stack
                    sx={{
                      // border: "1px solid blue",
                      width: {
                        xl: "100%",
                        lg: "100%",
                        md: "100%",
                        sm: "100%",
                        xs: "40%",
                      },
                      paddingRight: { xl: "24px", xs: "8px" },
                      paddingTop: "12px",
                      paddingBottom: { xs: "12px", sm: "0px" },
                    }}
                  >
                    <TextField
                      variant="outlined"
                      placeholder="Search..."
                      size="small"
                      fullWidth
                      value={searchTerm}
                      onChange={handleSearch}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IoSearch style={{ fontSize: "28px" }} />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-root": {
                          color: "1px solid #ddd",
                          "& fieldset": {
                            borderColor: "1px solid #ddd",
                          },
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "1px solid black",
                          },
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color: "black",
                        },
                      }}
                    />
                  </Stack>
                </Stack>

                <Grid
                  container
                  spacing={2}
                  ref={scrollableRef}
                  sx={{
                    position: "relative",
                    overflowY: "auto",
                    // border: "2px solid red",
                    // Hide scrollbar
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    msOverflowStyle: "none", // For Internet Explorer
                    scrollbarWidth: "none", // For Firefox
                    height: { xs: "auto" },
                    // border: "1px solid red",
                    backgroundColor: "#edf9ff",
                  }}
                >
                  {filteredCards.length > 0 ? (
                    filteredCards.slice(0, visibleCards).map((card, index) => (
                      <Grid item xs={6} sm={4} md={4} lg={4} xl={4} key={index}>
                        <CustomCard
                          blogId={card.postId || "1000"}
                          image={card.postImage || "Image 1000"}
                          title={card.postTitle || "Title 1000"}
                          tags={card.postChip || "postChip 1000"}
                          onReadMore={() => handleReadMore(card)}
                        />
                      </Grid>
                    ))
                  ) : (
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        width: "100%",
                        height: { sm: "82vh", xs: "52vh" },
                      }}
                    >
                      <Stack
                        sx={{
                          width: { xl: "80%" },
                          // border: "3px solid green",
                          marginTop: {
                            xl: "40px",
                            lg: "40px",
                            md: "40px",
                            sm: "40px",
                          },

                          marginBottom: {
                            xl: "40px",
                            lg: "40px",
                            md: "40px",
                            sm: "40px",
                            xs: "0px",
                          },
                        }}
                      >
                        <img
                          src={Img1}
                          alt="img"
                          style={{ height: "100%", width: "100%" }}
                        />
                      </Stack>
                    </Stack>
                  )}
                </Grid>

                {/* Dialog Box */}

                <Dialog
                  open={dialogOpen}
                  onClose={handleDialogClose}
                  fullWidth
                  maxWidth="md"
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      // border: "1px solid red",
                    }}
                  >
                    <IconButton onClick={handleDialogClose}>
                      <IoClose size={24} /> {/* React Icon for Close */}
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          selectedCard?.postHtmlSourceCode ||
                          "<p>No content available</p>",
                      }}
                      style={{
                        border: "1px solid #ddd",
                        padding: "20px",
                        background: "#f9f9f9",
                        borderRadius: "10px",
                      }}
                    ></div>
                  </DialogContent>
                </Dialog>

                {showBuffer && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      marginTop: "16px",
                      fontWeight: "bold",
                      color: "gray",
                    }}
                  >
                    <CircularProgress color="inherit" size={24} />
                  </Typography>
                )}
                {/* <Stack
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: {
                      xl: "26%",
                      lg: "18%",
                      md: "14%",
                      sm: "14%",
                      xs: "8%",
                    },
                    backgroundColor: "#ffffffcc",
                    display: {
                      xl: "none",
                      lg: "none",
                      md: "none",
                      sm: "none",
                      xs: "flex",
                    },
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 2,
                    boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                    //   border: "2px solid red",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#4c3bea",
                      fontWeight: "bold",
                      cursor: "pointer",
                      fontSize: { xl: "44px" },
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                    onClick={handleShowMore}
                  >
                    Show More
                  </Typography>
                </Stack> */}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BlogSection2;
